<template>
  <aside
    :class="[
      'py-4 transition-all duration-300 ease-in-out overflow-hidden hidden lg:block',
      isMinimized ? 'w-0 px-0' : 'w-80 px-2',
    ]"
  >
    <div class="bg-base-100 space-y-4 rounded-2xl shadow-md h-full border border-base-content/10">
      <div class="grid place-items-center pt-4">
        <img
          src="@/assets/logo/logo-dark.png"
          :class="[isTheme === 'dark' ? 'w-28 block' : 'hidden']"
          alt="logo"
        />
        <img
          src="@/assets/logo/logo-white.png"
          :class="[isTheme === 'light' ? 'w-28 block' : 'hidden']"
          alt="logo"
        />
      </div>
      <NavMenu />
    </div>
  </aside>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'
import { useUtilsStore } from '@/stores'
import NavMenu from './NavMenu.vue'

export default defineComponent({
  name: 'NavSidebar',
  components: { NavMenu },
  setup() {
    const useUtils = useUtilsStore()
    const isMinimized = computed(() => useUtils.isMinimized)
    const isTheme = computed(() => useUtils.isTheme)
    return { isMinimized, isTheme }
  },
})
</script>

<style></style>
